// src/i18n.js

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import HttpApi from 'i18next-http-backend';
import defaultEnglish from "./app/locales/en/default.json";
import defaultArabic from "./app/locales/ar/default.json";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // .use(HttpApi) // load translations using http (default public/locales)
  .use(initReactI18next) // pass the i18n instance to react-i18next
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    debug: false,
    resources: {
      en: {
        default: defaultEnglish
      },
      ar: {
        default: defaultArabic
      }
    },
    ns: ["default"],
    defaultNS: "default",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

const updateDocumentDirection = (lng) => {
  const direction = lng === "ar" ? "rtl" : "ltr";
  document.body.dir = direction;
};

i18n.on("languageChanged", updateDocumentDirection);

// Initially set the direction based on the default language
updateDocumentDirection(i18n.language);

export default i18n;
